import React from "react";
import { SealCheck } from "@phosphor-icons/react";

/**
 * Small brand-accent badge that flags a coach as platform-verified.
 * Rendered inline next to a coach's name. Renders nothing when `verified` is falsy.
 *
 * Sizes: "xs" (12) | "sm" (14) | "md" (18)
 * `showLabel` toggles the "VERIFIED" text next to the seal.
 */
export default function VerifiedBadge({ verified, size = "sm", showLabel = false, className = "" }) {
  if (!verified) return null;
  const px = size === "xs" ? 12 : size === "md" ? 18 : 14;
  return (
    <span
      className={`inline-flex items-center gap-1 text-brand-accent ${className}`}
      title="Verified by Edge Training"
      data-testid="verified-badge"
    >
      <SealCheck size={px} weight="fill" aria-label="Verified coach" />
      {showLabel && (
        <span className="label-tiny text-[10px] tracking-widest">VERIFIED</span>
      )}
    </span>
  );
}
